var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
            'pp-ui-button': _vm.applyStyles,
            'pp-ui-button-muted': _vm.applyStyles && _vm.muted,
            'pp-ui-button-unmuted': _vm.applyStyles && !_vm.muted,
         },on:{"click":function($event){return _vm.toggleMuted()}}},[_vm._t("default",function(){return [(_vm.muted)?_c('Muted'):_c('Unmuted')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }